import * as React from 'react';

export default class UserListItem extends React.Component {
  handleRowClick = (e) => {
    const { onRowClick } = this.props;
    if (typeof onRowClick !== 'function') return;
    onRowClick(e);
  };

  handleRowKeyDown = (e) => {
    const { onRowClick } = this.props;
    if (typeof onRowClick !== 'function') return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onRowClick(e);
    }
  };

  render = () => {
    const {
      id,
      nombreUsuario,
      email,
      baja,
      onRowClick
    } = this.props;
    const isInactivo = baja === true;
    const cardEstado = isInactivo ? 'admin-list-card--inactivo' : 'admin-list-card--vigente';

    return (
      <div
        className={`admin-list-card p-3 ${cardEstado} ${onRowClick ? 'cursor-pointer' : ''}`}
        onClick={this.handleRowClick}
        onKeyDown={this.handleRowKeyDown}
        role={onRowClick ? 'button' : undefined}
        tabIndex={onRowClick ? 0 : undefined}
      >
        <div className="row g-2 g-md-3 align-items-center">
          <div className="col-auto">
            <span className="admin-id-badge">{id}</span>
          </div>
          <div className="col-12 col-sm-5 col-md-4 col-lg-5">
            <div className="admin-list-card__title fw-semibold small mb-0 text-break">
              {nombreUsuario}
            </div>
          </div>
          <div className="col-12 col-sm d-flex flex-wrap align-items-center gap-2 justify-content-sm-end">
            <span className="small text-break mb-0">
              <i className="fas fa-envelope me-1 text-body-secondary" aria-hidden="true" />
              {email || '—'}
            </span>
            <span
              className="admin-metric-pill"
              title={isInactivo ? 'Usuario inactivo' : 'Usuario activo'}
            >
              <i className={`fas ${isInactivo ? 'fa-user-slash' : 'fa-user-check'}`} aria-hidden="true" />
              {isInactivo ? 'Inactivo' : 'Activo'}
            </span>
          </div>
        </div>
      </div>
    );
  };
}
